const { range } = require("d3");
var d3 = require("d3");

var dataviz = document.getElementById('dataviz-chart-aduhelm-cost');

var size = {
    width: 546,
    height: 340
}

var margin = {
    top: 16,
    left: 8,
    right: 8,
    bottom: 20
}

var scaleFactor = 1000000;

var medicareBudget = 37000000000 / scaleFactor;

var aduhelmCostDefault = 33454400000 / scaleFactor;

var aduhelmMin = 34608000000,
    aduhelmMax = 346080000000;

var rangeWrap = d3.select("#dataviz-chart-aduhelm-cost").append("div").attr("class", "range-wrap");

rangeWrap.append("div")
    .html("How much Aduhelm could cost Medicare")
    .attr("class", "chart-title")

rangeWrap.append("div")
    .html("Percent of seniors with Alzheimer's disease taking Aduhelm")
    .attr("class", "range-slider-label")

var inputSlider = rangeWrap.append("input")
    .attr("type", "range")
    .attr("class", "range")
    .attr("min", 2)
    .attr("max", 33)
    .attr("value", 10)
    .on("input", function() { transition(this.value) });

rangeWrap.append("div").attr("class", "bubble");

function transition(value) {
    costEstimate = (56000*1.03)*(5800000*(value / 100)) / scaleFactor;

    aduhelmRect.transition()
        .duration(100)
        .attr("width", Math.sqrt(costEstimate))
        .attr("height", Math.sqrt(costEstimate));

    var formattedAmount = Math.round( costEstimate / 100 ) / 10;

    aduhelmLabel.transition()
        .duration(100)
        .style("font-size", Math.sqrt(costEstimate) / 6 + 2 + "px")
        .text("$" + formattedAmount + "B")

    d3.selectAll(".aduhelm-cost-label").transition()
        .duration(90)
        .attr("y", Math.sqrt(costEstimate) / 6 + margin.top * 1.7 + 2)
    
    d3.selectAll(".aduhelm-cost-label2").transition()
        .duration(90)
        .attr("y", Math.sqrt(costEstimate) / 6 + margin.top * 1.7 + 14)
}

var svg = d3.select("#dataviz-chart-aduhelm-cost").append("svg")
    .attr("viewBox", "0 0 " + size.width + " " + size.height)
    .attr("font-family", "Circular, sans-serif")
    .attr("preserveAspectRatio", "xMinYMin meet");

svg.append("rect")
    .attr("x", 1)
    .attr("y", Math.sqrt(medicareBudget) + 10)
    .attr("stroke", "#888888")
    .attr("fill", "#ffffff")
    .attr("width", Math.sqrt(1000000000 / scaleFactor))
    .attr("height", Math.sqrt(1000000000 / scaleFactor))
    .attr("class", "medicare-budget")

svg.append("text")
    .attr("x", Math.sqrt(1000000000 / scaleFactor) + 5)
    .attr("y", Math.sqrt(medicareBudget) + 28)
    .attr("fill", "#888888")
    .style("font-size", "10px")
    .text("= $1 billion")

svg.append("rect")
    .attr("x", 0)
    .attr("y", 0)
    .attr("fill", "#888888")
    .attr("width", Math.sqrt(medicareBudget))
    .attr("height", Math.sqrt(medicareBudget))
    .attr("class", "medicare-budget")

var aduhelmRect = svg.append("rect")
    .attr("x", Math.sqrt(medicareBudget) + margin.left)
    .attr("y", 0)
    .attr("fill", "#1fadb6")
    .attr("width", Math.sqrt(aduhelmCostDefault))
    .attr("height", Math.sqrt(aduhelmCostDefault))
    .attr("class", "medicare-budget")

var medicareLabel = svg.append("text")
    .attr("x", margin.left + 8 )
    .attr("y", margin.top )
    .attr("fill", "#ffffff")
    .attr("dominant-baseline", "hanging")
    .style("font-size", Math.sqrt(medicareBudget) / 6 + 2 + "px")
    .attr("font-weight", "bold")
    .text("$" + Math.round(medicareBudget / 100) / 10 + "B")

svg.append("text")
    .attr("x", margin.left + 8 )
    .attr("y", Math.sqrt(medicareBudget) / 6 + margin.top * 1.7 + 2)
    .attr("fill", "#ffffff")
    .style("font-size", "10px")
    .text("Total Medicare spending on")

svg.append("text")
    .attr("x", margin.left + 8 )
    .attr("y", Math.sqrt(medicareBudget) / 6 + margin.top * 1.7 + 14 )
    .attr("fill", "#ffffff")
    .style("font-size", "10px")
    .text("drugs administered by doctors")

var aduhelmLabel = svg.append("text")
    .attr("x", margin.left + Math.sqrt(aduhelmCostDefault) + margin.left + 12 )
    .attr("y", margin.top )
    .attr("fill", "#ffffff")
    .attr("dominant-baseline", "hanging")
    .style("font-size", Math.sqrt(aduhelmCostDefault) / 6 + 2 + "px")
    .attr("font-weight", "bold")
    .text("$" + Math.round( aduhelmCostDefault / 100 ) / 10 + "B")

svg.append("text")
    .attr("x", margin.left + Math.sqrt(aduhelmCostDefault) + margin.left + 12 )
    .attr("y", Math.sqrt(aduhelmCostDefault) / 6 + margin.top * 1.7 + 2 )
    .attr("fill", "#ffffff")
    .attr("class", "aduhelm-cost-label")
    .style("font-size", "10px")
    .text("Potential")

svg.append("text")
    .attr("x", margin.left + Math.sqrt(aduhelmCostDefault) + margin.left + 12 )
    .attr("y", Math.sqrt(aduhelmCostDefault) / 6 + margin.top * 1.7 + 14 )
    .attr("fill", "#ffffff")
    .attr("class", "aduhelm-cost-label2")
    .style("font-size", "10px")
    .text("Aduhelm cost")

console.log("test");